import { showErrorToast } from "@/services";

export const formatErrorMessage = (error) => {
  const apiErrorMessage = error?.response?.data?.error;

  const statusError = error.response?.status
    ? `${error.response?.status}, ${error?.response?.statusText}`
    : null;
  const defaultError = "Ошибка при выполнении запроса";
  return apiErrorMessage || statusError || defaultError;
};

export const handleApiError = (error, options = {}) => {
  const { showToast = true, throwError = false } = options;

  if (showToast) {
    showErrorToast(formatErrorMessage(error));
  }
  return throwError
    ? Promise.reject(error)
    : Promise.reject(formatErrorMessage(error));
};
